import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

// Import pages
import OverviewPage from './pages/Overview/OverviewPage';
import FinancialsPage from './pages/Financials/FinancialsPage';
import RisksPage from './pages/Risks/RisksPage';
import ValuationPage from './pages/Valuation/ValuationPage';
import ManagementPage from './pages/Management/ManagementPage';
import QAPage from './pages/QA/QAPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/overview" element={<OverviewPage />} />
        <Route path="/financials" element={<FinancialsPage />} />
        <Route path="/risks" element={<RisksPage />} />
        <Route path="/valuation" element={<ValuationPage />} />
        <Route path="/management" element={<ManagementPage />} />
        <Route path="/qa" element={<QAPage />} />
        <Route path="/" element={<Navigate to="/overview" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
